/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IWebgroupCategoriesViewProps } from './webgroup-categories';

export default (props: IWebgroupCategoriesViewProps) => {
    return <div className='webgroup-categories'>{props.categories}</div>;
};
